import React, { useState } from "react";
import { CheckIcon } from "@heroicons/react/24/solid";
import BusinessInformation from "../BusinessInfo/Index";
import Categories from "../Categories/Index";
import MediaInfo from "../MediaInfo/Index";
import WorkingHours from "../WorkingHours/Index";
import ReviewAndSubmit from "../Review/Index";

const steps = [
    { id: "1", name: "Business Info" },
    { id: "2", name: "Categories" },
    { id: "3", name: "Media Info" },
    { id: "4", name: "Working Hours" },
    { id: "5", name: "Review & Submit" },
];

const Stepper = () => {
    const [currentStep, setCurrentStep] = useState(0);

    const renderStepContent = () => {
        const handleNext = () => {
            if (currentStep < steps.length - 1) {
                setCurrentStep((prevStep) => prevStep + 1);
            }
        };

        const handlePrevious = () => {
            if (currentStep > 0) {
                setCurrentStep((prevStep) => prevStep - 1);
            }
        };

        switch (currentStep) {
            case 0:
                return <BusinessInformation onNext={handleNext} />;
            case 1:
                return <Categories onNext={handleNext} onPrevious={handlePrevious} />;
            case 2:
                return <MediaInfo onNext={handleNext} onPrevious={handlePrevious} />;
            case 3:
                return <WorkingHours onNext={handleNext} onPrevious={handlePrevious} />;
            case 4:
                return <ReviewAndSubmit onPrevious={handlePrevious} />;
            default:
                return <p>Invalid step</p>;
        }
    };

    return (
        <div className="overflow-x-hidden">
            {/* Stepper Navigation */}
            <nav aria-label="Progress">
                <ol
                    role="list"
                    className="divide-y divide-gray-300 rounded-md border border-gray-300 md:flex md:divide-y-0"
                >
                    {steps.map((step, index) => (
                        <li key={step.name} className="relative md:flex md:flex-1">
                            {index < currentStep ? (
                                <button
                                    onClick={() => setCurrentStep(index)}
                                    className="group flex w-full items-center"
                                >
                                    <span className="flex items-center px-6 py-4 text-sm font-medium">
                                        <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-green-600 group-hover:bg-green-800">
                                            <CheckIcon aria-hidden="true" className="size-6 text-white" />
                                        </span>
                                        <span className="ml-4 text-sm font-medium text-gray-900">
                                            {step.name}
                                        </span>
                                    </span>
                                </button>
                            ) : index === currentStep ? (
                                <button
                                    aria-current="step"
                                    className="flex items-center px-6 py-4 text-sm font-medium"
                                >
                                    <span className="flex size-10 shrink-0 items-center justify-center rounded-full border-2 border-green-600">
                                        <span className="text-green-600">{step.id}</span>
                                    </span>
                                    <span className="ml-4 text-sm font-medium text-green-600">{step.name}</span>
                                </button>
                            ) : (
                                <button
                                    onClick={() => setCurrentStep(index)}
                                    className="group flex items-center"
                                >
                                    <span className="flex items-center px-6 py-4 text-sm font-medium">
                                        <span className="flex size-10 shrink-0 items-center justify-center rounded-full border-2 border-gray-300 group-hover:border-gray-400">
                                            <span className="text-gray-500 group-hover:text-gray-900">{step.id}</span>
                                        </span>
                                        <span className="ml-4 text-sm font-medium text-gray-500 group-hover:text-gray-900">
                                            {step.name}
                                        </span>
                                    </span>
                                </button>
                            )}
                        </li>
                    ))}
                </ol>
            </nav>

            {/* Step Content */}
            <div className="mt-6 max-w-7xl mx-auto">{renderStepContent()}</div>
        </div>
    );
};

export default Stepper;
